<template>
  <div class="letter-index">
    <a v-for="l in letters" :key="l" @click="jumpToLetter(l)">{{l}}</a>
  </div>
</template>

<script>
export default {
  name: 'LetterIndex',
  props: ["letters", "link-prefix"],
  methods: {
    jumpToLetter (letter) {
      const el = document.getElementById(`${this.linkPrefix}${letter}`);
      if (el != null) {
        el.scrollIntoView(false);
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.letter-index {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 40px;
  background-color: #f0f0f0;
  padding: 10px 0;
}

.letter-index > a {
  display: block;
  color: #2655FF;
  font-size: 22px;
  font-weight: 700;
  margin: 0 10px;
  padding: 0 5px;
  cursor: pointer;
  box-sizing: border-box;
  border-bottom: 2px solid transparent;
}

.letter-index > a:hover {
  border-bottom: 2px solid #2655FF;
}
</style>
